// extracted by mini-css-extract-plugin
export default {"defaultText":"structure_defaultText__3k+sW"};